export const RefundLabelTextHelper = {
    getLabelText: {
        refundId: 'Refund ID',
        orderNumber: 'Order Number',
        marketplaceCode: 'Marketplace Code',
        dateRefundOn: 'Refund Date',
        refundType: 'Refund Type',
        balanceType: 'Balance Type',
        description: 'Description',
        refundAmount: 'Refund Amount',
        refundCurrencyCode: 'Refund Currency',
        reason: 'Reason',
        remarks: 'Remarks',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        dateRefundOnFrom: 'Refund Date From',
        dateRefundOnTo: 'Refund Date To',
        action: 'Action'
    }
};
